import React from "react"

import SEO from "../components/seo"
import HomePageRedesign from "../components/homepage/homepageredesign"
import { useContentfulFaq } from "../hooks/useContentfulFaq"

const IndexPage = () => {
  const cfFaqData = useContentfulFaq()

  return (
    <>
      <SEO
        title="Hair Wellness from Within"
        description="Discover the #1 dermatologist-recommended hair growth supplements for men and women. Clinically proven and 100% drug-free, using patented technology for visibly thicker hair and less shedding."
      />
      <HomePageRedesign cfFaqData={cfFaqData?.["homepage-faq"]} />
    </>
  )
}

export default IndexPage
